// Tags an Error as safe to show verbatim to a customer. ErrorMessage (in
// LoginAlert.tsx) renders error.message only for a LoginDisplayError;
// everything else (e.g. an Axios error whose message is "Request failed
// with status code 401") falls back to generic copy instead.
//
// Lives in its own module, separate from LoginAlert.tsx's presentational
// components, because it is a cross-package contract: consumers outside
// @verifime/components (e.g. verifime-portal-web's
// @verifime/cognito-passwordless-auth package) construct and throw
// LoginDisplayError instances, so it is imported far more widely than the
// presentational components it happens to be used by here.
export class LoginDisplayError extends Error {}
